var _rect, _path, _circle, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDirectHandoffSf(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 22.692,
    height: 15.21,
    rx: 1.5,
    stroke: "#000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M.227 5.735h23.238M9.975 6.235v1.37a.5.5 0 00.5.5h2.74a.5.5 0 00.5-.5V5.61"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.581,
    cy: 14.452,
    r: 4.919,
    fill: "#fff",
    stroke: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.871 13.952a.5.5 0 100 1v-1zm5.773.853a.5.5 0 000-.707l-3.182-3.182a.5.5 0 00-.707.707l2.828 2.829-2.828 2.828a.5.5 0 00.707.707l3.182-3.182zm-5.773.147h5.42v-1h-5.42v1z",
    fill: "#000"
  })));
}
export default SvgIconDirectHandoffSf;